import {Typography} from 'components/Typography';
import React, {FC} from 'react';
import style from './style.module.scss';
import {capitalizeFirstChar} from 'core/helpers/string';
import Icon from 'components/Icon';

export interface IProps {
    onClear: () => void;
    title: string;
}

export const AppliedFilterSingleItem: FC<IProps> = ({onClear, title}) => {
    return (
        <div className={style.main} data-skeleton-item={true}>
            <Typography variant={'label-14-r'}>{capitalizeFirstChar(title)}</Typography>
            <button className={style.button} onClick={onClear} type={'button'}>
                <Icon className={style.icon} icon={'clear-filter'} />
            </button>
        </div>
    );
};
